/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable jsx-a11y/anchor-is-valid */
//import react
import React, { useState, useEffect } from 'react';
// import Icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';
// import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
// import CSS
import './index.css';
import './nav.css';
import './sideBar.css';
import './main.css';
import './footer.css';
import './backToTop.css';
import './header.css';
//import componentes
import NavSearch from './NavSearch';
import NavAvatar from './NavAvatar';
//import PageTitle from './PageTitle';
//import datos
import navList from '../../data/navItem';
// eslint-disable-next-line no-unused-vars
import ReporteManifiesto from "../siee/reporteManifiesto";
//import * as React from 'react';
//import { createRoot } from 'react-dom/client';
//import Empleados from "../Dashboard/GridEmpleados";
import { Grid } from '@progress/kendo-react-grid';
import { TileLayout, TileLayoutRepositionEvent } from "@progress/kendo-react-layout";
import CumpleanosCards from '../Dashboard/RecursosHumanos/GridCard';
import Vacaciones from '../Dashboard/RecursosHumanos/GridVacaciones';
import Viaticos from '../Dashboard/RecursosHumanos/GridViaticos';
import GraficaEmpleados from '../Dashboard/RecursosHumanos/Grafica';
import Aniversario from '../Dashboard/RecursosHumanos/GridAniversario';
import { fit } from '@progress/kendo-drawing';
//const root = createRoot(document.querySelector('my-app'));
//const [page, setpage] = useState('');
//const [contenido, setcontenido] = useState();


const opciones = ["reportemanifiesto"];
function index() {
  const [selectedPage, setSelectedPage] = useState("reportemanifiesto");
    return (
      <>
        <Header />
        <SideBar setSelectedPage={setSelectedPage} />
        <Main selectedPage={selectedPage} />
        <Footer />
        <BackToTop />
      </>
    );
  }

  function Header() {
    return (
      <header id="header" className="header fixed-top d-flex align-items-center">
        <Logo />
        <Nav />
      </header>
    );
  }
  function Logo() {
    const handleToggleSideBar = () => {
      document.body.classList.toggle('toggle-sidebar');
    };
    return (
      <div className="d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <span className="d-none d-lg-block">SIAGRI</span>
        </a>
        <i
          className="bi bi-list toggle-sidebar-btn"
          onClick={handleToggleSideBar}
        ></i>
      </div>
    );
  }
  function Nav() {
  return (
    <nav className="header-nav ms-auto">
      <ul className="d-flex align-items-center">
        <NavSearch />
        <NavAvatar />
      </ul>
    </nav>
  );
  }
 function SideBar({ setSelectedPage }) {
  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">

        {/* SIEE */}
        <li className="nav-item">
          <a className="nav-link collapsed" data-bs-toggle="collapse" href="#siee-nav">
            <i className="bi"></i>
            <span>SIEE</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>

          <ul id="siee-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
            <li>
              <a
                onClick={() => setSelectedPage("reportemanifiesto")}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-circle"></i>
                Reporte Manifiesto con fecha de venta
              </a>
            </li>
          </ul>
        </li>

        {/* DASHBOARD */}
        <li className="nav-item">
          <a className="nav-link collapsed" data-bs-toggle="collapse" href="#dash-nav">
            <i className="bi"></i>
            <span>Dashboard</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>

          <ul id="dash-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
            <li>
              <a
                onClick={() => setSelectedPage("dashboard")}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-circle"></i>
                Recursos Humanos
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </aside>
  );
}
  function Main({ selectedPage }) {
   
  const today = new Date();

    const formattedDate = new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    }).format(today);

    const formattedDateMonth = new Intl.DateTimeFormat("es-ES", {
      month: "long"
    }).format(today);

    const [positions, setPositions] = useState([
      { col: 1, colSpan: 1, rowSpan: 1 }, // Cumpleaños
      { col: 2, colSpan: 1, rowSpan: 1 }, // Asistencia
      { col: 3, colSpan: 2, rowSpan: 1 }, // Vacaciones
      { col: 2, colSpan: 3, rowSpan: 1 }, // Viaticos
      { col: 1, colSpan: 1, rowSpan: 1 } // Aniversario
    ]);

  return (
    <main id="main" className="main">

      {selectedPage === "reportemanifiesto" && (
        <ReporteManifiesto />
      )}

      
          {selectedPage === "dashboard" && (
            <>
              <TileLayout
                columns={4}
                rowHeight={358}
                gap={{ rows: 10, columns: 10 }}
                reorderable={true}
                resizable={true}
                positions={positions} // Estado que definimos
                items={[
                  { header:`🎂 Cumpleañeros del mes de ${formattedDateMonth}`,body: <CumpleanosCards /> },
                  { header:`Asistencia del dia ${formattedDate}`,body: <GraficaEmpleados/>},
                  { header:`Vacaciones del mes de ${formattedDateMonth}`,body: <Vacaciones /> },
                  { header:`Viaticos del mes de ${formattedDateMonth}`,body: <Viaticos /> },
                  { header:`Aniversarios del mes de ${formattedDateMonth}`,body: <Aniversario/>}
                ]}
                onReposition={(e) => setPositions(e.value)}
              />
            </>
          )}


    </main>
  );
}
//  <PageTitle  />
  function Footer() {
    return (
      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright{' '}
          <strong>
            <span>SIAGRI</span>
          </strong>
          . All Rights Reserved
        </div>
        <div className="credits">
          Designed by <a href="#">AGRI-TECH</a>
        </div>
      </footer>
    );
  }
  function BackToTop() {
    const [scroll, setScroll] = useState(0);
  
    useEffect(() => {
      window.addEventListener('scroll', () => {
        setScroll(window.scrollY);
      });
      return () => {
        window.removeEventListener('scroll', () => {
          setScroll(window.scrollY);
        });
      };
    }, [scroll]);
  
    const backToTop = () => {
      window.scrollTo(0, 0);
    };
  
    return (
      <a
        onClick={backToTop}
        className={`back-to-top d-flex align-items-center justify-content-center 
        ${scroll > 100 ? 'active' : undefined}`}
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    );
  }
  export default index;
  